export const SET_ALL_USERS = 'SET_ALL_USERS'
export const APPEND_USERS = 'APPEND_USERS'
export const SET_USERS_TOTAL = 'SET_USERS_TOTAL'
export const SET_EDIT_USER_MODE = 'SET_EDIT_USER_MODE'
export const SET_USER_GROUPS = 'SET_USER_GROUPS'
export const SET_USER_LOADING = 'SET_USER_LOADING'
export const SET_USER_DUPLICATE_PIN_CODE_ERROR = 'SET_USER_DUPLICATE_PIN_CODE_ERROR'
